var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.white ? 'white' : '', _vm.primary ? 'primary' : '', _vm.fourth ? 'fourth': '', _vm.small ? 'small': '', _vm.active ? 'active': '', _vm.circle ? 'circle': '' ],on:{"click":_vm.emitEvent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }